import SearchAutocomplete from './SearchAutocomplete.container';

export default SearchAutocomplete;
